var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"return-notes-list tab-table p-2"},[_c('return-notes-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }